import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';

import InvitationForm from './InvitationForm'
import imgBG from "../../../assets/images/bg-invitation.png"
import imgMain from "../../../assets/images/invitation-main.png"
import { AppIcon } from '../../../shared/components';
import { getContributor } from '../../../services/api-contributor';

const Invitation = () => {
  const [isShowForm, setIsShowForm] = useState(false);
  const navigate = useNavigate();
  const { code } = useParams();

  const { data, isSuccess } = useQuery('contributor', () => getContributor(code), {
    onError: async () => navigate('/', { replace: true }),
    retry: false,
    staleTime: Infinity
  })

  const renderWelcome = () => <main className="fixed h-full w-full flex justify-center items-center">
    <img
      src={imgBG} alt=""
      className="hidden sm:block inset-0 object-cover	w-full h-full absolute brightness-40"
    />

    <article className="relative h-full sm:h-auto flex flex-col w-full lg:pb-10 sm:max-w-[90%] sm:w-[619px]">
      <img src={imgMain} alt="" className="object-cover w-full min-h-[35%]"/>

      <div className="bg-white py-9 px-12 md:px-20 text-center flex-1 flex flex-col justify-center">
        <AppIcon name="logo" className="mb-3 h-7 mx-auto" />
        <h1 className="primary-title mb-3 text-[28px] leading-none max-w-[280px] mx-auto">
          Welcome to the canvs street art platform!
        </h1>

        <p className="font-helvetica leading-tight mb-7">
          Join the CANVS community and together create the most comprehensive street art library in the world!
        </p>

        <button
          onClick={() => setIsShowForm(true)}
          type="button"
          disabled={!isSuccess}
          className="btn-default bg-secondary hover:bg-green-400 text-white uppercase w-72 max-w-full mx-auto"
        >
          Get Started
        </button>
      </div>
    </article>
  </main>;

  return <>
    { isShowForm ? <InvitationForm data={data}/> : renderWelcome() }
  </>
}

export default Invitation;